module.exports = {
	"risks": [
		{
			"measures": {
				"monitor": {
					"text": "Continue to monitor and remain alert for any potential increase in risk",
					"checked": false
				},
				"changes": {
					"text": "Communicate any change in behaviours, that may put others at risk to the unit manager / supervisor",
					"checked": false
				},
				"communication": {
					"text": "Ensure communication devices processes are in place - (e.g. phone, personal safety / man-down alarm, check-in protocol; respectfully terminate client engagement/visit if concerns arise)",
					"checked": false
				}
			},
			"type": "Low"
		},
		{
			"measures": {
				"flag": {
					"text": "Apply flag alert",
					"checked": false
				},
				"notify": {
					"text": "Promptly notify program manager / supervisor so they can inform relevant staff and coordinate appropriate staffing and workflow",
					"checked": false
				},
				"alert": {
					"text": "Alert security and request assistance as needed. Ensure to inform security of risk management plan",
					"checked": false
				},
				"scan": {
					"text": "Scan environment for potential risks and remove if possible",
					"checked": false
				},
				"public": {
					"text": "Arrange to meet client in a public location as needed",
					"checked": false
				},
				"sectionC": {
					"text": "Ensure section C is completed and initiate the violence prevention care planning process - care plan should address known triggers, behaviours and include safety measures appropriate for the situation for both clients and workers",
					"checked": false
				},
				"therapeutic": {
					"text": "Use effective therapeutic communication e.g. maintain a calm reassuring demeanor, remain non-judgemental and empathetic, and provide person-centered care",
					"checked": false
				},
				"selfProtection": {
					"text": "Be prepared to apply behaviour management and self-protection teachings according to organizational policy / procedures that are appropriate for the situation - training programs provided may include GPA, Montessori, SMG, P.I.E.C.E.S, U-First Me & U-First, Stay Safe, MOAB training, and Self Defense",
					"checked": false
				},
				"communication": {
					"text": "Ensure communication devices processes are in place - (e.g. phone, personal safety / man-down alarm, check-in protocol; respectfully terminate client engagement/visit if concerns arise)",
					"checked": false
				},
				"changes": {
					"text": "Communicate any change in behaviours, that may put others at risk to the unit manager / supervisor",
					"checked": false
				},
				"informClient": {
					"text": "Inform client of VAT (Violence Assessment Tool) results, when safe to do so",
					"checked": false
				}
			},
			"type": "Moderate"
		},
		{
			"measures": {
				"flag": {
					"text": "Apply flag alert",
					"checked": false
				},
				"highAlertNotify": {
					"text": "Promptly notify program manager / supervisor so they can ensure relevant staff are on high alert and ready to respond",
					"checked": false
				},
				"alert": {
					"text": "Alert security and request assistance as needed. Ensure to inform security of risk management plan",
					"checked": false
				},
				"scan": {
					"text": "Scan environment for potential risks and remove if possible",
					"checked": false
				},
				"public": {
					"text": "Arrange to meet client in a public location as needed",
					"checked": false
				},
				"sectionC": {
					"text": "Ensure section C is completed and initiate the violence prevention care planning process - care plan should address known triggers, behaviours and include safety measures appropriate for the situation for both clients and workers",
					"checked": false
				},
				"therapeutic": {
					"text": "Use effective therapeutic communication e.g. maintain a calm reassuring demeanor, remain non-judgemental and empathetic, and provide person-centered care",
					"checked": false
				},
				"selfProtection": {
					"text": "Be prepared to apply behaviour management and self-protection teachings according to organizational policy / procedures that are appropriate for the situation - training programs provided may include GPA, Montessori, SMG, P.I.E.C.E.S, U-First Me & U-First, Stay Safe, MOAB training, and Self Defense",
					"checked": false
				},
				"referrals": {
					"text": "Initiate applicable referrals",
					"checked": false
				},
				"communication": {
					"text": "Ensure communication devices processes are in place - (e.g. phone, personal safety / man-down alarm, check-in protocol; respectfully terminate client engagement/visit if concerns arise)",
					"checked": false
				},
				"highAlertChanges": {
					"text": "Communicate any change in behaviours, that may put others at risk to the unit manager / supervisor so they can coordinate appropriate client placement, unit staffing, and workflow",
					"checked": false
				},
				"codeWhite": {
					"text": "Call 911 / activate PSRS as necessary",
					"checked": false
				},
				"informClient": {
					"text": "Inform client of VAT (Violence Assessment Tool) results, when safe to do so",
					"checked": false
				}
			},
			"type": "High"
		},
		{
			"measures": {
				"flag": {
					"text": "Apply flag alert",
					"checked": false
				},
				"highAlertNotify": {
					"text": "Promptly notify program manager / supervisor so they can ensure relevant staff are on high alert and ready to respond",
					"checked": false
				},
				"alert": {
					"text": "Alert security and request assistance as needed. Ensure to inform security of risk management plan",
					"checked": false
				},
				"scan": {
					"text": "Scan environment for potential risks and remove if possible",
					"checked": false
				},
				"public": {
					"text": "Arrange to meet client in a public location as needed",
					"checked": false
				},
				"sectionC": {
					"text": "Ensure section C is completed and initiate the violence prevention care planning process - care plan should address known triggers, behaviours and include safety measures appropriate for the situation for both clients and workers",
					"checked": false
				},
				"therapeutic": {
					"text": "Use effective therapeutic communication e.g. maintain a calm reassuring demeanor, remain non-judgemental and empathetic, and provide person-centered care",
					"checked": false
				},
				"selfProtection": {
					"text": "Be prepared to apply behaviour management and self-protection teachings according to organizational policy / procedures that are appropriate for the situation - training programs provided may include GPA, Montessori, SMG, P.I.E.C.E.S, U-First Me & U-First, Stay Safe, MOAB training, and Self Defense",
					"checked": false
				},
				"referrals": {
					"text": "Initiate applicable referrals",
					"checked": false
				},
				"communication": {
					"text": "Ensure communication devices processes are in place - (e.g. phone, personal safety / man-down alarm, check-in protocol; respectfully terminate client engagement/visit if concerns arise)",
					"checked": false
				},
				"highAlertChanges": {
					"text": "Communicate any change in behaviours, that may put others at risk to the unit manager / supervisor so they can coordinate appropriate client placement, unit staffing, and workflow",
					"checked": false
				},
				"codeWhite": {
					"text": "Call 911 / activate PSRS as necessary",
					"checked": false
				},
				"informClient": {
					"text": "Inform client of VAT (Violence Assessment Tool) results, when safe to do so",
					"checked": false
				}
			},
			"type": "Very High"
		}
	],
	"type": "Community Care"
};


//////////////////
// WEBPACK FOOTER
// ./src/initialStore/communityCare.json
// module id = 882
// module chunks = 0